export const STORE_STATE = 'store_state'
export const X_TOKEN = 'X-Token'
